export const userProfile = {
  user_personalInformation: "My personal information",
  user_alias: "Alias",
  user_alias_edit: "Edit alias",
  user_alias_placeholder: "Choose your alias",
  user_alias_save: "Save",
  user_alias_cancel: "Cancel",
  user_alias_saving: "Saving...",
  user_alias_success: "Alias updated",
  user_alias_error: "Could not update alias",
  user_alias_unavailable: "This alias is already in use",
  user_alias_checking: "Checking...",
  user_alias_available: "Available",
  user_alias_min_length: "Minimum 3 characters",
  user_name: "Name",
  user_lastName: "Last Name",
  user_email: "Email",
  user_phoneNumber: "Phone Number",
  user_birthdate: "Date of Birth",
  user_national_id: "ID Number",
  user_state: "State",
  user_city: "City",
  user_support_message: "To make any changes or updates to your profile, please contact our",
  user_support_link: "technical support",

  userProfileImageFormat: "Unsupported format",
  userProfileImageFormatDesc: "Only JPEG, JPG, or PNG images are allowed.",
  userProfileImageSize: "Image too large",
  userProfileImageSizeDesc: "The maximum allowed size is 3MB.",
  userProfileImageEdit: "Edit",

  profileFollowers: "Followers",
  profileFollowing: "Following",
  profileFavoriteGames: "Favorite Games",
  profileRecentGames: "Recent Games",
  profileFavoriteProviders: "Followed Providers",
  profileEditProfile: "Edit Profile",
  profileKeepPlaying: "Keep Playing",
  profileFollow: "Follow",
  profileNoFavorites: "No favorite games yet",
  profileNoFavoritesDesc: "Games you mark as favorites will appear here",
  profileNoRecentGames: "No recent games",
  profileNoRecentGamesDesc: "Games you play will appear here",
  profileNoProviders: "You're not following any providers yet",
  profileGamesCount: "{{count}} games",

  profileHighlightBigWins: "Big Wins",
  profileHighlightFavorites: "Favorites",
  profileHighlightRecent: "Recent",
  profileHighlightAchievements: "My achievements",
  profileHighlightLatestWinners: "Latest Winners",
  profileHighlightPopularGames: "Popular Games",
  profileHighlightLastPlayed: "Last Played",
  profileHighlightNoWins: "No big wins recorded yet",

  profileFeedTabs: "Profile feed tabs",
  profileNoBigWins: "No big wins yet",
  profileNoBigWinsDesc: "Your winning moments will appear here",

  profileAchievementsSections: "Achievement sections",
  profileAchievementsHome: "Home",
  profileAchievementsMissions: "Missions",
  profileAchievementsEmptyHome: "Nothing to show yet",
  profileAchievementsRank: "Rank",
  profileAchievementsXpPoints: "XP Points",
  profileAchievementsMyRewards: "My rewards",
  profileAchievementsActiveMissions: "Active missions",
  profileAchievementsSeeAll: "See all",
  profileAchievementsInProgress: "In progress",
  profileAchievementsLive: "Live",
  profileAchievementsPlayNow: "Play now",
  profileAchievementsDurationDays: "{{count}} days",
  profileAchievementsTournamentType_most_points: "Most points",
  profileAchievementsTournamentType_highest_win_multiplier: "Highest win",
  profileAchievementsEligibility_all: "Everyone",
  profileAchievementsEligibility_ranks: "Ranks",
  profileAchievementsEligibility_segment: "Segment",
  profileAchievementsTournamentStatus_scheduled: "Scheduled",
  profileAchievementsTournamentStatus_ended: "Ended",
  profileAchievementsTournaments: "Tournaments",
  profileAchievementsShop: "Shop",
  profileAchievementsBoosters: "Boosters",
  profileAchievementsRewards: "Rewards",
  profileAchievementsDisabled: "Gamification is unavailable",
  profileAchievementsEmptyMissions: "No active missions",
  profileAchievementsEmptyTournaments: "No tournaments available",
  profileAchievementsEmptyShop: "The shop is empty for now",
  profileAchievementsEmptyBoosters: "No active boosters",
  profileAchievementsEmptyRewards: "No pending rewards",
  profileAchievementsJoined: "Joined",
  profileAchievementsOptInRequired: "Opt-in required",
  profileAchievementsStock: "{{count}} available",
  profileAchievementsBooster_level: "Level booster",
  profileAchievementsBooster_token: "Token booster",
  profileAchievementsBooster_mission: "Mission booster",
  profileAchievementsBoostersTile: "Boosters",
  profileAchievementsMyBoosters: "My boosters",
  profileAchievementsEmptyBoostersModal: "No boosters available",
  profileAchievementsEasterEgg_pending: "Find",
  profileAchievementsEasterEgg_claimable: "Claim",
  profileAchievementsEasterEgg_claimed: "Claimed",
  profileAchievementsEasterEggTitle: "Easter egg",
  profileAchievementsEasterEggOhNo: "Oh no!",
  profileAchievementsEasterEggPendingBody:
    "Sorry, this Easter egg cannot be claimed yet. Complete more missions and try again later.",
  profileAchievementsEasterEggReady: "Ready!",
  profileAchievementsEasterEggReadyBody: "You can claim this Easter egg now.",
  profileAchievementsEasterEggKeepPlaying: "Keep playing",
  profileAchievementsEasterEggClaiming: "Claiming…",
  profileAchievementsEasterEggClaimError: "Could not claim. Try again later.",
  profileAchievementsMissionTitle: "Mission",
  profileAchievementsEndsIn: "Ends in: {{time}}",
  profileAchievementsMissionRewards: "Mission rewards",
  profileAchievementsMissionRewardsHint: "Complete all missions to unlock this exclusive chest.",
  profileAchievementsObjectives: "Objectives",
  profileAchievementsObjectivesCount: "{{count}} objectives",
  profileAchievementsTerms: "Terms and conditions",
  profileAchievementsTermsEmpty: "No terms are available for this mission.",
  profileAchievementsTournamentGames: "Tournament games",
  profileAchievementsSearch: "Search",
  profileAchievementsAll: "All",
  profileAchievementsNoGamesFound: "No games were found",
  profileAchievementsNoGamesFoundHint:
    "We didn't find games that match your search. Try adjusting the filters or explore our full collection.",
  profileAchievementsProductDetails: "Product details",
  profileAchievementsLowStock: "Low stock",
  profileAchievementsStockLeft: "Only {{count}} left in stock",
  profileAchievementsBuyNow: "Buy now",
  profileAchievementsBuying: "Buying…",
  profileAchievementsNotEnoughTokens: "You don't have enough tokens to buy this product",
  profileAchievementsBuyError: "Could not complete the purchase. Try again later.",
  profileAchievementsSoldOut: "Sold out",

  profileNoFollowers: "No followers yet",
  profileNoFollowing: "Not following anyone yet",
  profileFollowersSoon: "This feature will be available soon",

  friendAddFriend: "Follow",
  friendStatusPending: "Request sent",
  friendStatusFriends: "Friends",
  friendRequestSentToast: "Friend request sent",
  friendRequestSentTitle: "Request sent",
  friendRequestSentBody: "Your friend request has been sent",
  friendRequestReceivedTitle: "Friend request",
  friendRequestReceivedBody: "{{alias}} sent you a friend request",
  friendUnfriendTitle: "Unfriend?",
  friendUnfriendDescription: "Do you want to unfriend @{{alias}}?",
  friendUnfriendConfirm: "Confirm",
  friendUnfriendCancel: "Cancel",
  friendUnfriendLoading: "Removing...",
};
